import { jsx as s } from "react/jsx-runtime";
import a from "../../button/Button.js";
import "../../loader/Loader.js";
import '../../../assets/DialogClose.css';const e = {
  "dialog-close": "_dialog-close_17dyt_2"
}, c = ({ onClick: o, icon: t = "cross" }) => /* @__PURE__ */ s(a, { type: "button", leadingIcon: t, variant: "tertiary", className: e["dialog-close"], onClick: o });
export {
  c as default
};
